// ABOUTME: The owner's view of a request an outside platform sent, for its thread
// card: current state and cancel. Shapes mirror app/services/marketing_tasks/
// payloads.py::task_card (snake_case, no mapping layer).
import { api } from '@/api/client'

export type PlatformRequestStatus =
  | 'received'
  | 'in_progress'
  | 'awaiting_owner_approval'
  | 'completed'
  | 'failed'
  | 'cancelled'

export interface PlatformRequest {
  id: string
  platform: string
  credential_id: string
  status: PlatformRequestStatus
  brief: string
  publish_requested: boolean
  approval_id: string | null
  summary: string | null
  draft_ids: string[]
  preview_urls: string[]
  report_urls: string[]
  error: string | null
  created_at: string | null
}

export async function getPlatformRequest(id: string): Promise<PlatformRequest> {
  return (await api.get<PlatformRequest>(`/platform-requests/${id}`)) as unknown as PlatformRequest
}

export async function cancelPlatformRequest(id: string): Promise<PlatformRequest> {
  return (await api.post<PlatformRequest>(
    `/platform-requests/${id}/cancel`
  )) as unknown as PlatformRequest
}
